var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M13.3955 1.39551L15.1055 0.40918L16.0918 2.11816L18 1.60742L18.5107 3.51465H20.4854V5.48828L22.3926 6L21.8809 7.90723L23.5908 8.89453L22.6035 10.6035L24 12L22.6035 13.3955L23.5908 15.1055L21.8809 16.0918L22.3926 18L20.4854 18.5107V20.4854H18.5107L18 22.3926L16.0918 21.8809L15.1055 23.5908L13.3955 22.6035L12 24L10.6035 22.6035L8.89453 23.5908L7.90723 21.8809L6 22.3926L5.48926 20.4854H3.51465V18.5107L1.60742 18L2.11816 16.0918L0.40918 15.1055L1.39551 13.3955L0 12L1.39551 10.6035L0.40918 8.89453L2.11816 7.90625L1.60742 6L3.51465 5.48828V3.51465H5.48926L6 1.60742L7.90723 2.11816L8.89453 0.40918L10.6035 1.39551L12 0L13.3955 1.39551Z",
    fill: "#6B7EFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 256 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5925 8.19442C18.0374 8.52158 18.1329 9.14751 17.8057 9.59246L11.9234 16.5925C11.7355 16.848 11.4375 16.9992 11.1204 17.0001C10.8032 17.0009 10.5044 16.8512 10.3152 16.5967L6.19755 12.0582C5.86804 11.615 5.96021 10.9886 6.40342 10.6591C6.84664 10.3296 7.47306 10.4218 7.80257 10.865L11.1133 14.318L16.1944 8.40768C16.5216 7.96273 17.1475 7.86725 17.5925 8.19442Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.131f70e2de63416dec9554f2fe35a6b7.svg";
export { ForwardRef as ReactComponent };